module.exports = __webpack_public_path__ + "static/assets/cb4cf63f247d343f9a667fccb0df90d5.png";